import { ComputedCheckboxInput } from '@framework/form/inputs/computed/ComputedCheckboxInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { ParagraphSizeText } from '../../common/style/ParagraphSizeText.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IComputedBooleanWidget } from '../IComputedWidget.ts';

export interface IComputedBooleanWidgetComponentProps
  extends IWidgetComponentProps<IComputedBooleanWidget> {}

export function ComputedBooleanWidgetComponent(
  props: IComputedBooleanWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options?.helpText ? (
          <RichTextAdvancedRender inline text={options?.helpText} />
        ) : undefined
      }
      layout={{
        hideVisualLabel: options?.hideLabel,
        removeLabelSpace: props.widget.layout?.isTableColumn,
      }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <ComputedCheckboxInput
        name={options.name}
        tabIndex={options.preview ? -1 : undefined}
        readOnly={props.readonly}
      >
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={options.text} />
        </ParagraphSizeText>
      </ComputedCheckboxInput>
    </ConfigFormItem>
  );
}
